<app-navigation [tagline]="'CHECK'" [marginLeftClass]="'ml-60'"></app-navigation>


<ion-content fullscreen style="overflow: hidden" scroll-y="false">
  <div class="ion-padding" style="background-color: black;">
    <ion-progress-bar color="progressbar" style="height: 10px; border-bottom: 1px solid #ffffff; background: #000000" value="{{progress}}">
    </ion-progress-bar>
  </div>
  <swiper-container #swiperContainer
                    [spaceBetween]="100"
                    (swiperinit)="onSwiperInit($event)"
                    (swiperslidenexttransitionstart)="checkSliderStatus()"
                    (swiperslideprevtransitionstart)="checkSliderStatus()"
  >

      <!--ion-slides options="sliderOptions" (ionSlidesDidLoad)="initSlider()" (ionSlideNextStart)="checkSliderStatus()"
        (ionSlidePrevStart)="checkSliderStatus()"-->
      <swiper-slide *ngFor="let question of questions; let i = index"
                 [class.answered]="question.answer !== null">
        <div *ngIf="popupData[i].hasPopup; else titleWithoutPopup" class="question">
          <span [innerHTML]="popupData[i].textBeforeLink"></span>
          <ion-text class="popupLink" (click)="showInfoPopup($event,question.textInfoBox)">{{ popupData[i].linkText }}
          </ion-text>
          <span [innerHTML]="popupData[i].textAfterLink"></span>
        </div>
        <ng-template #titleWithoutPopup>
          <div class="outerQuestion">
            <div class="question" [innerHTML]="renderHtml(question.title)">
            </div>
          </div>
        </ng-template>
        <ion-toolbar color="transparent">
          <ion-icon (click)="selectItem(i,true)"
                    style=" font-size: 60px; margin-left:25%"
                    class="shadow"
                    [src]="questions[i].answer === true?'assets/img/hand-thumbs-up-fill.svg':'assets/img/hand-thumbs-up.svg'"
                    [class.selected]="questions[i].answer === true"
          ></ion-icon>
          <ion-icon (click)="selectItem(i,false)" slot="end"
                    style=" font-size: 60px; margin-right:25%"
                    class="shadow"
                    [class.selected]="questions[i].answer === false"
                    [src]="questions[i].answer === false?'assets/img/hand-thumbs-down-fill.svg':'assets/img/hand-thumbs-down.svg'"
          ></ion-icon>
        </ion-toolbar>
        <div class="feedbackContainer" *ngIf="(question.answer !== null)">
          <div class="feedback"
               [innerHTML]="(question.answer === true)?renderHtml(question.feedbackTextYes):renderHtml(question.feedbackTextNo)">
          </div>
        </div>
        <ion-toolbar color="transparent" *ngIf="question.answer !== null">
          <ion-icon (click)="last()"
                    style=" font-size: 60px;"
                    src="assets/img/arrowLast.svg"
          ></ion-icon>
          <ion-icon (click)="next()" slot="end"
                    src="assets/img/arrowNext.svg"
                    style=" font-size: 60px;"
          >
          </ion-icon>
        </ion-toolbar>
      </swiper-slide >
      <swiper-slide  style="display: block;">
        <p>Das war es schon mit den Fragen!</p>

        <p>
          Wir hoffen, wir haben Dich etwas zum <b>Nachdenken</b> gebracht und mit dem einen oder anderen
          <b>Vorurteil</b> gegenüber Studium und Ausbildung aufgeräumt. Im besten Fall hat es auch etwas Spaß gemacht.
        </p>
        <app-buttons (clickedNext)="toResult()" [showLastButton]="false">
          <ion-icon style="font-size: 2em;" name="ribbon-outline"></ion-icon>
        </app-buttons>
      </swiper-slide >
  </swiper-container>
    <!--/ion-slides-->
</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-title class="footer">#ORIENTANDO</ion-title>
  </ion-toolbar>
</ion-footer>
